<div class="cfe-page">

  <div class="cfe-card">

    <!-- Header de la tarjeta -->
    <div class="cc-page-header cc-page-header--form">
      <div class="cc-page-header-title">
        <i class="pi pi-database"></i>
        <span>{{ 'CATALOG.EDIT' | translate }}</span>
      </div>
    </div>

    <!-- Cuerpo -->
    <div class="cfe-card-body">
      <form [formGroup]="form">

        <!-- Sección: Información básica -->
        <section class="cfe-form-section">
          <h4 class="cfe-section-title">{{ 'CATALOG.SECTION_BASIC' | translate }}</h4>
          <formly-form [form]="form" [fields]="basicFields" [model]="model"></formly-form>
        </section>

        <!-- Sección: Importación -->
        <section class="cfe-form-section">
          <h4 class="cfe-section-title">{{ 'CATALOG.SECTION_IMPORT' | translate }}</h4>
          <formly-form [form]="form" [fields]="importFields" [model]="model"></formly-form>
          <div class="cfe-test-btn-row">
            <p-button
              [label]="'CATALOG.TEST_IMPORT' | translate"
              icon="pi pi-link"
              [text]="true"
              severity="secondary"
              size="small"
              (onClick)="testImportUrl()"
            ></p-button>
          </div>
        </section>

        <!-- Sección: Exportación -->
        <section class="cfe-form-section">
          <h4 class="cfe-section-title">{{ 'CATALOG.SECTION_EXPORT' | translate }}</h4>
          <formly-form [form]="form" [fields]="exportFields" [model]="model"></formly-form>
          <div class="cfe-test-btn-row">
            <p-button
              [label]="'CATALOG.TEST_EXPORT' | translate"
              icon="pi pi-link"
              [text]="true"
              severity="secondary"
              size="small"
              (onClick)="testExportUrl()"
            ></p-button>
          </div>
        </section>

        <!-- Sección: Campos extra -->
        <section class="cfe-form-section">
          <h4 class="cfe-section-title">{{ 'CATALOG.SECTION_EXTRA' | translate }}</h4>
          <formly-form [form]="form" [fields]="extraFields" [model]="model"></formly-form>
        </section>

      </form>
    </div>

  </div>

  <!-- Progress bar de re-sync -->
  <div *ngIf="loadingReSync">
    <p-progressBar mode="indeterminate" [style]="{ height: '4px' }" />
  </div>

  <!-- Acciones -->
  <div class="cfe-actions">
    <p-button
      [label]="'FORM.SAVE' | translate"
      size="small"
      [disabled]="saveButton"
      (onClick)="updateForm()"
    ></p-button>
  </div>

  <p-toast></p-toast>
</div>
